var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spacer",class:[_vm.cmsBlock.spacerBackgroundStyle, _vm.cmsBlock.spacing]})
}
var staticRenderFns = []

export { render, staticRenderFns }